import { all, fork } from 'redux-saga/effects';
import { loyaltyAccountInfo } from './LoyaltyAccountInfo';
import { login } from './Login';
import { loyaltyGift } from './LoyaltyGift';

export default function* rootSaga() {
    yield all([
        ...loyaltyAccountInfo,
        ...loyaltyGift,
        ...login,
    ])
}